import React from "react";
import { Formik, Field } from "formik";
import { Input, Row, Col, Select } from "antd";

import { emailValidator } from "../../utils";
import { FormInputField } from "../FormInputField/FormInputField";
import InputLabel from "../FloatingSelectLabel/FloatingSelectLabel";
const { Option } = Select;
const phoneDictionary = ['+92', '+93']

function UserForm({
  data, //optional parameter
  columnConfig, //required parameter
  toggleUpdateDisability, //disable button on error
  updateFormState,
  requestDisableStatus,
  disableStatusAllow,
}) {
  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [phoneCountryCode, setPhoneCountryCode] = React.useState('+92');
  const [status, setStatus] = React.useState(1);

  const [nameError, setNameError] = React.useState(null);
  const [emailError, setEmailError] = React.useState(null);
  const [phoneError, setPhoneError] = React.useState(null);

  const [statusSelectActive, setStatusSelectActive] = React.useState(false);

  const onPhoneChanged = (e) => {
    const newPhone = e.target.value;
    if (isNaN(newPhone) || newPhone.includes(".")) {
      setPhoneError("The phone number you entered is of incorrect format.");
    } else if (!(newPhone.length === 10 || newPhone.length === 0)) {
      setPhoneError("The phone number you entered is of incorrect length.");
    } else if (columnConfig?.phone?.isRequired && newPhone === "") {
      setPhoneError("New phone number cannot be empty.");
    } else {
      setPhoneError(null);
    }
    setPhone(newPhone);
  };

  const onNameChanged = (e) => {
    const newName = e.target.value;
    if (columnConfig?.name?.isRequired && newName === "")
      setNameError("The Name cannnot be empty");
    else if (newName?.length > 30)
      setNameError("The Name cannnot exceeds 30 characters");
    else setNameError(null);
    setName(newName);
  };

  const onEmailChange = (e) => {
    const newEmail = e.target.value;
    if (columnConfig?.email?.isRequired && newEmail === "")
      setEmailError("The Email cannnot be empty");
    else if (newEmail !== "" && emailValidator(newEmail))
      setEmailError("Email is incorrect");
    else setEmailError(null);
    setEmail(newEmail);
  };

  const onStatusDropDownValueChange = (value) => {
    if (disableStatusAllow) {
      requestDisableStatus();
    } else {
      setStatus(value);
    }
  };

  React.useEffect(() => {
    toggleUpdateDisability(phoneError || emailError || nameError);
  }, [phoneError, emailError, nameError]);

  React.useEffect(() => {
    toggleUpdateDisability(phoneError || emailError || nameError || [name, email, phone].includes('')) //disable on empty
    updateFormState({ name, email, phone: phoneCountryCode + phone, status });
  }, [name, email, phone, status]);

  React.useEffect(() => {
    if (![undefined, null].includes(data)) {
      setEmail(data?.email);
      setName(data?.fullName);
      setPhone(data?.phone?.slice(3));//remove countryCode.
      setStatus(data?.status === true ? 1 : 2);
    }
  }, [data]);

  return (
    <>
      <Formik
        initialValues={{
          status: "",
        }}
        enableReinitialize={true}
      >
        {(formikProps) => {
          return (
            <>
              <Row>
                <Col span={12} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="*Name"
                    hideErrorMessage={false}
                    isRequired={true}
                    value={name}
                    className="text-field"
                    placeholder={"—"}
                    onChange={onNameChanged}
                    disabled={columnConfig?.name?.isDisabled}
                    style={{ height: "42px" }}
                  />
                  {nameError && (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {nameError}
                    </span>
                  )}
                </Col>
                <Col span={12} className="column-right">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="*Email"
                    hideErrorMessage={false}
                    value={email}
                    className="text-field"
                    placeholder={"—"}
                    onChange={onEmailChange}
                    disabled={columnConfig?.email?.isDisabled}
                    style={{ height: "42px" }}
                  />
                  {emailError && (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {emailError}
                    </span>
                  )}
                </Col>
              </Row>
              <Row>
                <Col span={2} className="column-left">
                  <select
                    disabled={true}
                    value={phoneCountryCode}
                    style={{
                      width: "90px",
                      marginTop: "27px",
                      height: "39px",
                      backgroundColor: "white",
                      borderColor: "black",
                      border: "1px solid #D9D9D9",
                      borderRadius: "3px",
                      paddingLeft: "20px",

                    }}
                    onChange={(x) => setPhoneCountryCode(x.target.value)}
                  >
                    {phoneDictionary?.map(x => <option value={x}>{x}</option>)}
                  </select>
                </Col>
                <Col span={10} className="column-left">
                  <Field
                    InputType={Input}
                    component={FormInputField}
                    labelText="*Phone"
                    hideErrorMessage={true}
                    value={phone}
                    className="text-field"
                    disabled={columnConfig?.phone?.isDisabled}
                    placeholder={"—"}
                    onChange={onPhoneChanged}
                    style={{
                      marginBottom: phoneError && "-20px",
                      height: "42px",
                    }}
                  />
                  {phoneError && (
                    <span style={{ color: "red", marginLeft: "5px" }}>
                      {phoneError}
                    </span>
                  )}
                </Col>
                <Col span={12} className="column-right">
                  <div
                    onFocus={() => {
                      setStatusSelectActive(true);
                    }}
                    onBlur={() => {
                      setStatusSelectActive(false);
                    }}
                    style={{ marginTop: "25px", height: "40px" }}
                  // className="dropdowns"
                  >
                    <InputLabel
                      value={status}
                      labelText="Status"
                      active={statusSelectActive}
                    >
                      <Select
                        disabled={columnConfig?.status?.isDisabled}
                        value={status}
                        onChange={onStatusDropDownValueChange}
                        size="large"
                      >
                        <Option value={1}>Active</Option>
                        <Option value={2}>InActive</Option>
                      </Select>
                    </InputLabel>
                  </div>
                </Col>
              </Row>
            </>
          );
        }}
      </Formik>
    </>
  );
}

export default UserForm;
